'use strict';
const createWidgetFactory = require('components-framework/widget/create_widget_factory');

const getAccountInfoOk = function(data) {
    if (!this.model.initialized) {
        this.model.set({
            userDTO: data.userDTO,
            isActive: data.userDTO.status === 'ACTIVE',
        });
        this.showDetails();
    }
};
const changePasswordOk = function() {
    this.model.set('passwordChanged', true);
    this.hideHint();
    this.showDetails();
};
const cancelAccountOk = function() {
    Odigeo.Utils.eraseCookie('sso_remember_me');
    Odigeo.Utils.goToApplicationHome();
};
const errorPassword = function(data) {
    if (!Odigeo._.isEmpty(data) && !Odigeo._.isEmpty(data.messageError)) {
        this.model.set('errorPsw', data.messageError);
    }
    this.showDetails();
    this.model.set({
        error: '',
        errorPsw: '',
        passwordChanged: false,
    });
};
const errorAccount = function() {
    this.model.set('error', 'accountError');
    this.showDetails();
};
const clearChangePasswordFields = function() {
    this.clearPasswordFields();
};

const refreshKeys = function() {
    this.onRefreshKeys(this.model);
};

const checkDefaultBillingVisibility = function() {
    this.onCheckDefaultBillingVisibility();
};

module.exports = createWidgetFactory({
    name: 'account_preferences_manager',
    modelClass: require('./model'),
    viewClass: require('./view'),

    methods: {
        cancelAccountOk: cancelAccountOk,
        cancelAccountError: errorAccount,
        cancelAccountWithError: errorAccount,
        changePasswordOk: changePasswordOk,
        changePasswordError: errorPassword,
        changePasswordWithError: errorPassword,
        getAccountInfoOk: getAccountInfoOk,
        clearChangePasswordFields: clearChangePasswordFields,
        cancelMembershipOk: cancelAccountOk,
        cancelMembershipWithError: errorAccount,
        refreshKeys: refreshKeys,
        checkDefaultBillingVisibility: checkDefaultBillingVisibility,
    },
});
